interface Props {
  readonly size?: number;
  readonly className?: string;
  readonly title?: string;
}

export default function LockIcon(props: Props) {
  const { size = 16, ...rest } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.00052 3.21036C10.7937 3.21036 13.3098 4.84765 15.576 8.05558C13.3095 11.2629 10.7935 12.9 8.00052 12.9C5.20736 12.9 2.69124 11.2627 0.425003 8.05477C2.69155 4.84745 5.20753 3.21036 8.00052 3.21036Z"
        stroke="currentColor"
        strokeWidth="0.695652"
      />
      <path
        d="M8.00052 10.1322C9.10509 10.1322 10.0005 9.2023 10.0005 8.05518C10.0005 6.90805 9.10509 5.97812 8.00052 5.97812C6.89595 5.97812 6.00052 6.90805 6.00052 8.05518C6.00052 9.2023 6.89595 10.1322 8.00052 10.1322Z"
        stroke="currentColor"
        strokeWidth="0.695652"
      />
      <path
        d="M2.31129 13.7655L13.4092 2.24"
        stroke="currentColor"
        strokeWidth="0.695652"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
